import React from "react";
import styles from "../DomainSearchForm.scss";
import {getInitialMeta} from "@helpers/HelperInitialPageState";
import language from "@lang/language";
import TextBox from "@components/base/TextBox/TextBox";
import Button from "@components/base/Button/Button";

const Default = ({
					 data,
					 onSubmitForm,
					 inputRef,
					 buttonLayout = 'default',
					 showAllLink = false,
					 color = ''
				 }) => {

	if (!data || !onSubmitForm || !inputRef) {
		return null;
	}

	return (
	  <form
		action={''}
		onSubmit={onSubmitForm}
		autoComplete={"off"}>
		  <div className={styles.searchContainer}>
			  <TextBox
				ref={inputRef}
				name={'domainName'}
				id={'header_domain_search'}
				layout={'SearchTransparent'}
			  />

			  <Button
				type={'submit'}
				classNameConcat={styles.button}
				value={data.buttonText}
				layout={buttonLayout}
			  />

			  {showAllLink &&
				<a href={getInitialMeta('siteURL') + 'web-hosting-register-domains.php'}>{language.allDomains}</a>
			  }
		  </div>

		  <input type={'hidden'} name={'newmode'} value={'1'}/>
	  </form>
	);
}

export default Default;